import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom'
import { WxLayout } from '../../layout/wxLayout';
import WxHome from './pages/home';
import WxAutoReply from './pages/auto-reply';
import WxMass from './pages/mass';
import WxMenu from './pages/menu';
import WxPoster from './pages/poster';
import WxQrCode from './pages/qr-code';
import WxMassPrice from './pages/mass-price';

const App: React.FC = () => {

  return (
    <Router>
      {/* @ts-ignore */}
      <WxLayout >
        <Route exact path='/wx/' component={WxHome} />
        <Route exact path='/wx/auto-reply' component={WxAutoReply} />
        <Route exact path='/wx/mass' component={WxMass} />
        <Route exact path='/wx/menu' component={WxMenu} />
        <Route exact path='/wx/poster' component={WxPoster} />
        <Route exact path='/wx/qrcode' component={WxQrCode} />
        <Route exact path='/wx/mass-price' component={WxMassPrice} />
      </WxLayout>
    </Router>
  )
}

export default App